import type { FaireProductEntity } from "../../entity_types/product";

export const p_vmcr29rcv2: FaireProductEntity = {
  token: "p_vmcr29rcv2",
  type: "product",
  name: "Zen Buddha Energy Bracelet - 12 pcs",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/7a5770a12ffa1bbc727f81cd69d728bcb069efaa035a07a36f11c279926835d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d6692aedf587c4ba88c88ce23452a686a3092158098c4938163f144e92a18f1.jpeg",
    "https://cdn.faire.com/fastly/9d9b2dbce371dd986994f0bfb3314f3fcb08d57f17f01f6bf8e501dbd95bb992.jpeg",
    "https://cdn.faire.com/fastly/26909b0236b7be4da021b5224a3950b638c29e3eb7de0bf587a589fd87045c25.jpeg",
    "https://cdn.faire.com/fastly/3e9ccd8ae16cd7043147ab36570cc6a49376cc34035668f2082bbcb8464fd0df.jpeg",
    "https://cdn.faire.com/fastly/a04173685479c68f7a50dbcdc007a2e10685ac73fec315ad8c1f94fa164299ff.jpeg",
    "https://cdn.faire.com/fastly/f3688701e51a44b76fd71b9289f3125498429e1b37bb9e6d99d571036e602482.jpeg",
    "https://cdn.faire.com/fastly/7a38cd1c19a650fe7156087d4f959fd6add8dffd75b3c18809f50ab28c2ee224.jpeg",
    "https://cdn.faire.com/fastly/4a0fe6dcba1f85335126b46482e308a9ffddd50fbb2a3cd75f822604c58a70bd.jpeg",
    "https://cdn.faire.com/fastly/77a7a9490968fc266246f72e64b430760fed5688c292b9df9da1b8cafad1a56f.jpeg",
    "https://cdn.faire.com/fastly/561c3a002cc4919915591f78476571a6b19b923bc9aca517ba22f3ba61508a99.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Embrace inner peace and mindful living with our Zen Buddha Energy Bracelet, a beautiful fusion of natural gemstones, soft cords, and a delicate Buddha charm at the center — symbolizing wisdom, serenity, and spiritual awakening. Each bracelet is thoughtfully handcrafted with natural stone beads such as tiger’s eye, black onyx, turquoise, carnelian, lapis lazuli, or picture jasper, chosen for their unique energies to support your journey. The adjustable cord ensures a comfortable fit, while the Buddha charm serves as a daily reminder to stay grounded, compassionate, and connected to the present moment. Lightweight and versatile, this bracelet is perfect for layering, meditation practice, or gifting as a meaningful token of peace and protection.\n\nPackage Contents:\n1 case contains 12 bracelets ( 2 of each stone)\n\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:28.671Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
